module.exports = __webpack_public_path__ + "img/mail.d83558ca.svg";